// Mirrors EMessageRating of the AI assistant processor and the ES conversation document (VindFront has the same copy).
const EMessageRating = Object.freeze({
  None: 0,
  ThumbsUp: 1,
  ThumbsDown: 2
});

export default EMessageRating;
